import { useTranslator } from '@bluebeam/react-i18n';
import React, { FC } from 'react';

type Props = {};

const PlacePunchMessageOverlay: FC<Props> = () => {
  const { translate } = useTranslator(['mapView']);
  return (
    <div
      className="pos-a flex-center"
      style={{ zIndex: 3, top: '128px', left: 'calc(50vw - 157.5px)' }}
    >
      <div
        className="bgd-black-1-opacity-80 white-1 px4 py3 flex-center b-radius-3"
        style={{ width: '315px' }}
      >
        {translate('mapView:placePunchMessage.placePunchMarkupOnDrawing')}
      </div>
    </div>
  );
};

export default PlacePunchMessageOverlay;
